import { useEffect, useState } from 'react'
export const useBasketAdd = (store_current, cartItems_current) => {


    const [baskets, setBaskets] = useState(localStorage.getItem("baskets") ? JSON.parse(localStorage.getItem("baskets")) : []);
    const [isBasketOverFlow, setIsBasketOverFlow] = useState(false);

    useEffect(() => {
        if (store_current) {
            // alert(cartItems_current?.length)
            if ((cartItems_current ?? []).length == 0) {
                //basket is empty and remove
                localStorage.setItem("baskets", JSON.stringify(baskets.filter(basket => basket.id != store_current.id)))

            } else {
                if ((baskets ?? null).length == 0) {
                    //new basket add
                    localStorage.setItem("baskets", JSON.stringify([{
                        id: store_current.id,
                        store: store_current,
                        cartItems: cartItems_current,
                    }]))
                }
                else {
                    let baskets_runtime=localStorage.getItem("baskets") ? JSON.parse(localStorage.getItem("baskets")) : [];
                    if (baskets_runtime.filter((x) => x.id != store_current.id).length >= 3) {
                        //capacity full overflow baskets create error
                        setIsBasketOverFlow(true)
                    }
                    else {
                        // add basket 
                        localStorage.setItem("baskets", JSON.stringify([...baskets_runtime.filter(basket => basket.id != store_current.id), {
                            id: store_current.id,
                            store: store_current,
                            cartItems: cartItems_current,
                        }]))
                    }

                }
            }
        }
    }, [cartItems_current])

    return { isBasketOverFlow }
}